/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider } from '@mui/material/styles';

class DataTableStyled extends React.Component {
    getMuiTheme = (outerTheme) => createTheme({
        components: {
            MUIDataTableHeadCell: {
            },

            MuiTableCell: {
                styleOverrides: {
                    head: {
                        backgroundColor: '#1565c0 !important',
                        fontWeight: 'bold',
                        color: 'white',
                        padding: 3,
                    },
                    body: {
                        fontSize: '12px',
                        textAlign: 'center', // default: left
						padding: 3
                    },
                },
            },
            MUIDataTableBodyRow: {
                styleOverrides: {
                    root: {
						'&:nth-child(odd)': {
							backgroundColor: '#f2f2f2'
						},
					},

                }
            },
            MUIDataTablePagination: {},
            MUIDataTableViewCol: {},
            MUIDataTableSearch: {},
            MUIDataTableToolbar: {},
            MUIDataTableFilter: {},
            MUIDataTableFilterList: {},
            MUIDataTableBodyCell: {}
        }
    })

    render() {
        const {
			id,
			title = '',
			data = [],
			columns = [],
			options,
			// pagination = true,
			showDownload = false, // show download icon button
			showPrint = false, // show print icon button
			selectableRows = 'none', // multiple, single, none
			rowsPerPage = 20, // number of rows displayed by page
			filterType = 'multiselect', // filter type can be multiselect, texfield, etc.,
			tableBodyMaxHeight = '40em',
			...rest
		} = this.props;

    	return (
            <ThemeProvider theme={this.getMuiTheme()}>
    	        <MUIDataTable
	                title=""
	                data={data}
	                columns={columns}
	                options={{
                        tableBodyMaxHeight: '400px',
                        rowsPerPageOptions: [10, 15, 20, 100],
                        filterType,
                        download: showDownload,
                        print: showPrint,
                        selectableRows,
                        responsive: 'standard',
                        rowsPerPage,
                        onRowSelectionChange: this._onRowSelection,
                        fixedSelectColumn: true,
                        ...options,
                    }}
	                {...rest}
    	        />
    		</ThemeProvider>
  	);
    }
}

DataTableStyled.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string,
	data: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
	options: PropTypes.object,
	pagination: PropTypes.bool,
	showDownload: PropTypes.bool,
	showPrint: PropTypes.bool,
	selectableRows: PropTypes.string,
	rowsPerPage: PropTypes.number,
	filterType: PropTypes.string,
	tableBodyCellMaxWidth: PropTypes.string || PropTypes.number,
	actionColumnWidth: PropTypes.string || PropTypes.number,
	onRowSelection: PropTypes.func,
	tableBodyMaxHeight: PropTypes.string
};

export default DataTableStyled;
